import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Angular Material
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';

// Teller Online Libraries
import { TellerOnlineSharedModule } from 'teller-online-libraries/shared';
import { TellerOnlineIconsModule } from 'teller-online-libraries/icons';

// Components
import { TellerOnlineHelpComponent, TellerOnlineHelpSidebarComponent } from './components';

@NgModule({
    declarations: [
        TellerOnlineHelpComponent,
        TellerOnlineHelpSidebarComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        MatLegacyCardModule,
        MatLegacyListModule,
        MatLegacyFormFieldModule,
        MatLegacyInputModule,
        MatLegacyButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatLegacyTooltipModule,
        TellerOnlineSharedModule,
        TellerOnlineIconsModule
    ],
    exports: [
        TellerOnlineHelpComponent,
        TellerOnlineHelpSidebarComponent
    ]
})
export class TellerOnlineHelpModule {}
